'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _LibraryLoader2 = require('../models/LibraryLoader');

var _LibraryLoader3 = _interopRequireDefault(_LibraryLoader2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HlsJsPlayerLoader = function (_LibraryLoader) {
  (0, _inherits3.default)(HlsJsPlayerLoader, _LibraryLoader);

  function HlsJsPlayerLoader(libraryUrl) {
    (0, _classCallCheck3.default)(this, HlsJsPlayerLoader);

    var _this = (0, _possibleConstructorReturn3.default)(this, (HlsJsPlayerLoader.__proto__ || (0, _getPrototypeOf2.default)(HlsJsPlayerLoader)).call(this));

    _this.libraryUrl = libraryUrl;
    return _this;
  }

  (0, _createClass3.default)(HlsJsPlayerLoader, [{
    key: 'getPlayerLibrary',
    value: function getPlayerLibrary() {
      var hlsjs = global.window.hlsjs;

      return hlsjs && hlsjs.isSupported() ? hlsjs : null;
    }
  }]);
  return HlsJsPlayerLoader;
}(_LibraryLoader3.default);

exports.default = HlsJsPlayerLoader;
//# sourceMappingURL=HlsJsLoader.js.map